/* ── Risk ─────────────────────────────────────────────────────────────────────
   The score counts DOWN from 100. 100 is the ideal; low is bad. It has been
   inverted once already, in September 2026. Red <= 40, Amber <= 75. */
export const SCORE_RED = 40;
export const SCORE_AMBER = 75;
/* ── Anchors (SITE-RULES 2) ───────────────────────────────────────────────────
   Named and two-way, or it is not an anchor. Decaying is a THIRD state, not the
   absence of one, and an anchor is never deleted to say it went quiet. */
export const ANCHOR_DECAY_DAYS = 30; // "a month", per SITE-RULES 2
/* The reasons a lead actually gives, from the migration's 351 typed answers. "Something
   else" is not a bucket: picking it asks for the words and keeps them. */
export const DROPOUT_REASONS = [
    'Price',
    'Timetable did not work',
    'Distance',
    'Joined somewhere else',
    'Injury or health',
    'Moving away',
    'Not ready yet',
    'Never responded',
];
/* ── Paging: no endpoint ever returns the whole roster ───────────────────────── */
